export const veloeGraphQlApi = async (
  query,
  variables,
  authorization_token,
) => {
  const url = process.env.REACT_APP_GRAPHQL_API;
  const token = authorization_token || localStorage.getItem('token');
  const options = {
    method: 'POST', // API's graphQL só aceitam POST =))
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: token,
      token: token,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  };

  try {
    const response = await fetch(url, options);
    const body = await response.json();
    return body.data;
  } catch {
    throw new Error(
      'Ops, estamos passando por uma instabilidade. Tente novamente em breve.',
    );
  }
};

export const exMutation = `
  mutation ($id: Int, $mediaId: Int, $status: MediaListStatus) {
    SaveMediaListEntry (id: $id, mediaId: $mediaId, status: $status) {
      id
      status
    }
  }
`;
